import React from 'react';
import { Hand, Minus, Plus, Scan } from 'lucide-react';
import { cn } from '../../lib/utils';

const WorkflowCanvasControls = ({
  zoom,
  panMode,
  onTogglePanMode,
  onZoomIn,
  onZoomOut,
  onFitToScreen,
}) => (
  <div
    className="pointer-events-auto absolute bottom-6 left-4 z-30 flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white shadow-lg"
    data-testid="workflow-canvas-controls"
    data-workflow-canvas-controls
  >
    <button
      type="button"
      title="Pan"
      aria-label="Pan"
      aria-pressed={panMode}
      onClick={onTogglePanMode}
      className={cn(
        'flex h-9 w-9 items-center justify-center border-b border-slate-200 text-slate-600 transition-colors hover:bg-slate-50',
        panMode && 'bg-sky-50 text-sky-600',
      )}
      data-testid="canvas-pan-toggle"
    >
      <Hand size={16} />
    </button>
    <button
      type="button"
      title="Zoom in"
      aria-label="Zoom in"
      onClick={onZoomIn}
      className="flex h-9 w-9 items-center justify-center border-b border-slate-200 text-slate-600 hover:bg-slate-50"
      data-testid="canvas-zoom-in"
    >
      <Plus size={16} />
    </button>
    <div
      className="flex h-9 w-9 items-center justify-center border-b border-slate-200 text-[11px] font-medium text-slate-700"
      data-testid="canvas-zoom-label"
    >
      {zoom}%
    </div>
    <button
      type="button"
      title="Zoom out"
      aria-label="Zoom out"
      onClick={onZoomOut}
      className="flex h-9 w-9 items-center justify-center border-b border-slate-200 text-slate-600 hover:bg-slate-50"
      data-testid="canvas-zoom-out"
    >
      <Minus size={16} />
    </button>
    <button
      type="button"
      title="Fit to screen"
      aria-label="Fit to screen"
      onClick={onFitToScreen}
      className="flex h-9 w-9 items-center justify-center text-slate-600 hover:bg-slate-50"
      data-testid="canvas-fit-screen"
    >
      <Scan size={16} />
    </button>
  </div>
);

export default WorkflowCanvasControls;
